import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from "ngx-toastr";
import { of } from "rxjs/observable/of";
import {BASE_URL_SCAB} from "../util/constants";

@Injectable()
export class HttpInterceptorToken implements HttpInterceptor {

  constructor(
    private loading: NgxSpinnerService,
    private toast: ToastrService,
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    const url = request.url;
    return next.handle(request).pipe(
      map((event) => {
        if (event instanceof HttpResponse && (event.url.indexOf(BASE_URL_SCAB) > -1 && url.indexOf('login') === -1)) {
          this.loading.show();
        }

       /* if (event instanceof HttpResponse && event.body.hasOwnProperty('sucesso') && !event.body.sucesso) {
          throw new HttpErrorResponse({
            error: event.body.mensagens.join('<br/> '),
            headers: event.headers,
            status: 200,
            statusText: 'Warning',
            url: event.url
          });
        }*/
        return event;
      })/*,
      catchError((error, caught) => {
        console.log('ERROR===', error)
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            this.toast.error(error.error);
          } else {
            this.toast.error(`Ocorreu um erro inesperado - Código ${ error.status }`);
          }
        }

        return of(error);
      }),*/
      ,finalize(() => {
        this.loading.hide();
      })
    );

  }
}





// WEBPACK FOOTER //
// ./src/app/interceptors/http-interceptor-token.ts